import { ColumnFilter } from './ColumnFilter'; // Assuming you have a ColumnFilter component

export const COLUMNS = [
    {
        Header: 'اسم المورد',
        accessor: 'SupplierName',
        Filter: ColumnFilter,
    },
    {
         Header: 'رقم الهاتف',
        accessor: 'Phone',
        Filter: ColumnFilter,
        Cell: ({ value }) => value ? value : 'N/A', // Show 'N/A' if the phone number is not available
    },
    {
        Header: 'البريد الالكتروني',
        accessor: 'Email',
        Filter: ColumnFilter,
        Cell: ({ value }) => <a href={`mailto:${value}`}>{value}</a>, // Clickable email link
    },
    {
        Header: 'العنوان',
        accessor: 'Address',
        Filter: ColumnFilter,
    },
    
];
